@if (user) {
  <button mat-button class="user-menu-face-button" [matMenuTriggerFor]="menu" data-test="user-menu-face-button">
    <mat-icon class="face">face</mat-icon>
    @if (!mobile) {
      <span>{{user.nameAndOrganization}}</span>
    }
    <mat-icon iconPositionEnd>more_vert</mat-icon>
  </button>
  <mat-menu #menu="matMenu">
    <ng-content></ng-content>
    <a routerLink="/user-settings/profile" mat-menu-item>
      <mat-icon>account_circle</mat-icon>
      <span>User Settings</span>
    </a>
    <a routerLink="/reset-password" mat-menu-item>
      <mat-icon>security</mat-icon>
      <span>Reset Password</span>
    </a>
    <a routerLink="/logout" mat-menu-item>
      <mat-icon>exit_to_app</mat-icon>
      <span>Logout</span>
    </a>
  </mat-menu>
}
